module.exports = __webpack_public_path__ + "media/images/logo_pl-a5a6265d128fb6e265eba61afd4b0570.svg";